<template>
  <div :class="['social-medias', {'social-medias--light' : colorMode == 'light'}]">
    <h4 class="social-medias__title">{{ $t('getToKnowUs', lang) }}</h4>

    <a
      v-for="media in medias"
      :href="media.url"
      target="_blank"
      v-html="media.icon"
      :title="media.title"
      class="social-medias__link">
    </a>
  </div>
</template>

<script>
export default {
  name: "social-medias",

  props: {
    lang: { type: String, required: true }, // Lang binded from parent.
    colorMode: { type: String, required: false },
  },

  data() {
    return {
      medias: [
        {
          title: "Facebook",
          url: "https://www.facebook.com/MentosCanada",
          icon: '<svg viewBox="0 0 52 96.1" enable-background="new 0 0 52 96.1" xml:space="preserve"><path d="M50,0L37.5,0c-14,0-23.1,9.3-23.1,23.7v10.9H2c-1.1,0-2,0.9-2,2v15.8c0,1.1,0.9,2,2,2h12.5v39.9c0,1.1,0.9,2,2,2h16.4c1.1,0,2-0.9,2-2V54.3h14.7c1.1,0,2-0.9,2-2l0-15.8c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6H34.8v-9.2c0-4.4,1.1-6.7,6.8-6.7l8.4,0c1.1,0,2-0.9,2-2V2C52,0.9,51.1,0,50,0"></path></svg>'
        },
        {
          title: "Instagram",
          url: "https://www.instagram.com/mentoscanada",
          icon: '<svg viewBox="0 0 17 17" enable-background="new 0 0 17 17" xml:space="preserve"><path d="M15.3,3.8c0,0.3-0.2,0.4-0.4,0.4h-1.7c-0.3,0-0.4-0.2-0.4-0.4V2.1c0-0.3,0.2-0.4,0.4-0.4h1.7c0.3,0,0.4,0.2,0.4,0.4V3.8z M2.1,15.3c-0.3,0-0.4-0.2-0.4-0.4V7.6h1.8C3.4,7.9,3.4,8.2,3.4,8.5c0,2.8,2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1c0-0.3,0-0.6-0.1-0.9h1.8v7.2c0,0.3-0.2,0.4-0.4,0.4H2.1z M8.5,5.1c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4C5.1,6.6,6.6,5.1,8.5,5.1L8.5,5.1z M15.3,0H1.7C0.8,0,0,0.8,0,1.7v13.6C0,16.2,0.8,17,1.7,17h13.6c0.9,0,1.7-0.8,1.7-1.7V1.7C17,0.8,16.2,0,15.3,0L15.3,0z"/></svg>'
        },
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// SocialMedias.vue?44412aef